export const TEXT_CASES = {
    obligatorias: {
      label: 'Al seleccionar una Cuenta Obligatoria se congelará el total del saldo'
    },
    voluntarias: {
      label: 'Al seleccionar una Cuenta Voluntaria deberás ingresar el porcentaje de saldo que congelarás'
    },
    obligatorias_y_voluntarias: {
      label: 'Al seleccionar una Cuenta Obligatoria se congelará el total del saldo, mientras que en las Voluntarias deberás ingresar el porcentaje que desees congelar'
    }
}